import { Routes, RouterModule } from '@angular/router';
import { DataProtectionAuthoringToolsComponent } from './auth-tools/data-protection-authoring-tools/data-protection-authoring-tools.component';
import { DataProtectionDashboardComponent } from './auth-tools/data-protection-dashboard/data-protection-dashboard.component';
import { ReportsComponent } from './reports/reports.component';
import { AuthGuard } from 'src/app/core/guard/utility.guard';
import { DataAssetMappingComponent } from './data-asset-mapping/data-asset-mapping.component';
import { DataAssetMappingCreateOrUpdateComponent } from './data-asset-mapping/data-asset-mapping-create-or-update/data-asset-mapping-create-or-update.component';
import { DataProtectionProgramComponent } from './data-protection-program/data-protection-program.component';
import { DataProtectionProgramProcessComponent } from './data-protection-program/data-protection-program-process/data-protection-program-process.component';
import { DataProtectionDashboardDataResolver } from 'src/app/core/resolvers/data-protection/dashboard-data.resolver';
//import { DataProtectionDashboardDataResolver } from 'src/app/core/resolvers/data-protection/dashboard-data.resolver';

export const dataProtectionRoutes: Routes =[
    {
        path: 'data-protection/auth-tools',

        component: DataProtectionAuthoringToolsComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
     

      {path: 'data-protection-reports',component: ReportsComponent},  
            {
       path: '',
       component: DataProtectionDashboardComponent,
       resolve: { dashboard: DataProtectionDashboardDataResolver }
     },

      {path: 'data-asset-mapping',component: DataAssetMappingComponent},  

      {path: 'data-asset-mapping/create/:dataAssetId', component: DataAssetMappingCreateOrUpdateComponent, data: {create: true}},
       {path: 'data-asset-mapping/update/:dataAssetId', component: DataAssetMappingCreateOrUpdateComponent, data: {create: false}},

       
       {path: 'data-protection-program',component: DataProtectionProgramComponent},  
       {path: 'data-protection-program/process/:mappingId',component: DataProtectionProgramProcessComponent},  
       


     //**************Shared Workflows*********************/
      {
        path: 'system-asset-capture',
        loadChildren: () =>
          import(
            '../shared-workflows/system-asset-capture/system-asset-capture.module'
          ).then(m => m.SystemAssetCaptureModule)
      },
      {
        path: 'data-asset-capture',
        loadChildren: () =>
          import(
            '../shared-workflows/data-asset-capture/data-asset-capture.module'
          ).then(m => m.DataAssetCaptureModule)
      },
      {
        path: 'data-asset-configuration',
        loadChildren: () =>
          import(
            '../shared-workflows/data-asset-configuraion/data-asset-configuration.module'
          ).then(m => m.DataAssetConfigurationModule)
      },
       
      {
        path: 'security-zone-management',
        loadChildren: () =>
           import(
            '../shared-workflows/zone-management/zone-management.module'
          ).then(m => m.ZoneManagementModule),
      }
      
    ],
      },   

  ];

   export const dataProtectionRouter = RouterModule.forChild(dataProtectionRoutes);
